import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Link from "./Link";

// ====

const SocialLinks = (props) => {
  const { links, className, itemClassName, mode } = props;

  // Compute dynamic classNames here to keep JSX clean
  const listClassName = `list-unstyled ${mode === "inline" ? "list-inline" : ""
    } ${className && className}`;

  const listItemClassName = `${mode === "inline" ? "list-inline-item" : ""} brand-social-button ${itemClassName && itemClassName
    }`;

  // Reduce links prop to new list of <li> elements based on if a URL is supplied
  // Replaced map with reduce as map should be for 1 to 1 mapping
  const socialLinksListItems = links.reduce((currList, item, index) => {

    const { link, iconName, isHeybox = false } = item;

    // Ensure we have a URL to check otherwise skip to next item
    if (item && !!link) {
      let icon = ["fab", iconName];

      if (iconName === "forums") {
        icon = ["fas", "comments"];
      }

      // Here we know we can safely create a new list item with all details supplied
      currList.push(
        <li className={listItemClassName} key={index}>
          <Link
            to={link}
            aria-label={`External link to ${iconName}`}
            className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          >
            {isHeybox &&
              <img
                src="https://a.storyblok.com/f/156499/280x350/b314d93494/heybox-icon.png"
                alt={`Link to Heybox page`}
                style={{ height: "28px", }}
              />
            }
            {!isHeybox &&
              <FontAwesomeIcon icon={icon} />
            }
          </Link>
        </li>
      );
    }

    return currList;
  }, []);

  return <ul className={listClassName}>{socialLinksListItems}</ul>;
};

export default SocialLinks;

// ====

SocialLinks.propTypes = {
  links: PropTypes.oneOfType([PropTypes.array]),
  mode: PropTypes.string,
  className: PropTypes.string,
  itemClassName: PropTypes.string,
};
SocialLinks.defaultProps = {
  links: null,
  mode: "inline",
  className: null,
  itemClassName: null,
};
